const countryLangs: Partial<Record<string, string>> = {
    bi: 'fr',
    gm: 'en',
    gw: 'fr',
    km: 'fr',
    ls: 'en',
    mr: 'fr',
    re: 'fr',
    rw: 'en',
    sc: 'en',
    sl: 'en',
    ss: 'en',
    td: 'fr',
    yt: 'fr',
    zm: 'en',
    zw: 'en',
    ci: 'fr',
    bf: 'fr',
    cm: 'fr',
    tg: 'fr',
    sn: 'fr',
    ga: 'fr',
    gn: 'fr',
    bj: 'fr',
    cd: 'fr',
    ml: 'fr',
    gh: 'en',
    ng: 'en',
    lr: 'en',
    cg: 'fr',
    bw: 'en',
    za: 'en',
    so: 'en',
    ke: 'en',
    et: 'en',
    tz: 'en',
    cf: 'fr',
    ne: 'fr',
    ma: 'fr',
    dz: 'fr',
    tn: 'fr',
    eg: 'en',
    mw: 'en',
    ao: 'fr',
    na: 'en',
    mz: 'en',
    mg: 'fr',
    mu: 'fr',
    ug: 'en',
    dj: 'fr',
};

export function defaultLangForCountryOrNull(country: string): string | null {
    return countryLangs[country.toLowerCase()] ?? null;
}

export function defaultLangForCountry(country: string): string {
    const lang = countryLangs[country.toLowerCase()];
    return lang ?? 'fr';
}

export function defaultLocaleForCountry(country: string): string {
    const lang = defaultLangForCountry(country);
    return `${lang.toLowerCase()}-${country.toUpperCase()}`;
}
